import React, { useState, useEffect } from 'react'
import HeaderHome from '../../components/headerHome/HeaderHome';
import './RegistroEmpresas.css'
import { useNavigate, Link } from 'react-router-dom'
import { ContentBodyRegistroEmpresa } from '../../components/RegistroEmpresas/ContentBodyRegistroEmpresa'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'

export const RegistroEmpresas = () => {
  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext);
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false);
    }
  }
  const navigate = useNavigate();
  const olvidarContraseña = () => {
    navigate('/recuperarContraseña');
  }
  //<div onClick={navegar}>Si no itiene cuenta, <b>regístrese aquí.</b></div>
  return (
    <div className='Registro' onClick={closeMenu}>
      <div className='headerRegistroEmpresas'> <HeaderHome /> </div>
      <div className='bodyRegistro'>
        <div className='contentBodyRegistro'> <ContentBodyRegistroEmpresa /></div>
      </div>
      <div className='footerRegistro'> <MiFooter /> </div>
    </div>
  )
}

export default RegistroEmpresas;
